import { apiClient } from '@/services/_shared/apiClient';
import ENDPOINTS from '@/utils/endpoints';
import type {
  Package,
  PackageFilterParams,
  PaginationMeta,
} from '@/modules/packages/components/types';

export interface FetchPackagesResult {
  packages: Package[];
  pagination: PaginationMeta;
}

/**
 * GET /v1/packages/active - Fetch active packages with server-side filtering
 */
export const fetchActivePackagesAPI = async (
  filters: PackageFilterParams = {}
): Promise<FetchPackagesResult> => {
  const params: Record<string, string | number> = {};

  if (filters.package_type) params.package_type = filters.package_type;
  if (filters.da_min !== undefined) params.da_min = filters.da_min;
  if (filters.da_max !== undefined) params.da_max = filters.da_max;
  if (filters.dr_min !== undefined) params.dr_min = filters.dr_min;
  if (filters.dr_max !== undefined) params.dr_max = filters.dr_max;
  if (filters.traffic_min !== undefined) params.traffic_min = filters.traffic_min;
  if (filters.traffic_max !== undefined) params.traffic_max = filters.traffic_max;
  if (filters.spam_score_max !== undefined) params.spam_score_max = filters.spam_score_max;
  if (filters.sort_by) params.sort_by = filters.sort_by;
  if (filters.sort_order) params.sort_order = filters.sort_order;
  if (filters.per_page) params.per_page = filters.per_page;
  if (filters.page) params.page = filters.page;

  const response = await apiClient.get(ENDPOINTS.GET_ACTIVE_PACKAGES, { params });
  const payload = response.data;

  // API response: { status, message, data: { packages: [...], pagination: {...} } }
  const packages = payload?.data?.packages ?? [];
  const pagination: PaginationMeta = payload?.data?.pagination ?? {
    total: packages.length,
    per_page: filters.per_page ?? 20,
    current_page: 1,
    last_page: 1,
    from: packages.length > 0 ? 1 : null,
    to: packages.length > 0 ? packages.length : null,
  };

  return { packages, pagination };
};

/**
 * GET /v1/master/packages/{id} - Fetch a single package by ID
 */
export const fetchPackageByIdAPI = async (id: string): Promise<Package> => {
  const response = await apiClient.get(`${ENDPOINTS.GET_PACKAGE_BY_ID}/${id}`);
  const data = response.data;

  return data.data ?? data;
};
